import { render } from "./RegistrationPaymentRequests.vue?vue&type=template&id=6041918e&scoped=true"
import script from "./RegistrationPaymentRequests.vue?vue&type=script&lang=js"
export * from "./RegistrationPaymentRequests.vue?vue&type=script&lang=js"

import "./RegistrationPaymentRequests.vue?vue&type=style&index=0&id=6041918e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6041918e"]])

export default __exports__